import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar, MapPin, Video, ExternalLink } from 'lucide-react';

interface DateLocationCardProps {
  startDate: Date;
  endDate: Date;
  locationType: 'PHYSICAL' | 'VIRTUAL' | 'TO_BE_DECIDED';
  address: string | null;
}

export function DateLocationCard({
  startDate,
  endDate,
  locationType,
  address,
}: DateLocationCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Date & Time</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-start gap-3">
          <Calendar className="h-5 w-5 shrink-0 text-primary mt-0.5" />
          <div>
            <p className="font-medium">
              {startDate.toLocaleDateString(undefined, {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </p>
            <p className="text-sm text-muted-foreground">
              {startDate.toLocaleTimeString(undefined, {
                hour: 'numeric',
                minute: '2-digit',
              })}{' '}
              - {endDate.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })}
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3">
          {locationType === 'PHYSICAL' ? (
            <MapPin className="h-5 w-5 shrink-0 text-primary mt-0.5" />
          ) : locationType === 'VIRTUAL' ? (
            <Video className="h-5 w-5 shrink-0 text-primary mt-0.5" />
          ) : (
            <ExternalLink className="h-5 w-5 shrink-0 text-primary mt-0.5" />
          )}
          <div>
            <p className="font-medium">
              {locationType === 'PHYSICAL'
                ? 'In Person'
                : locationType === 'VIRTUAL'
                  ? 'Online'
                  : 'To be decided'}
            </p>
            <p className="text-sm text-muted-foreground">
              {locationType === 'PHYSICAL'
                ? address
                : locationType === 'VIRTUAL'
                  ? 'Link provided after registration'
                  : 'Location details coming soon'}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
